import { render, staticRenderFns } from "./CreateResourceContentSectionDialog.vue?vue&type=template&id=1b5d3ace&scoped=true"
import script from "./CreateResourceContentSectionDialog.vue?vue&type=script&lang=js"
export * from "./CreateResourceContentSectionDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateResourceContentSectionDialog.vue?vue&type=style&index=0&id=1b5d3ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5d3ace",
  null
  
)

export default component.exports